import React from "react"
import { Home, Book, Users, Calendar, Award, BookOpen, PlayCircle, Layers, Grid, UserCheck, Star, Copy, UserPlus } from 'react-feather'

export const Navigation = [
    {
        id: 'dashboard',
        title: 'user.nav.dashboard',
        icon: <Home size={20} />,
        navLink: '/dashboard',
        alwaysVisible: true
    },
    {
        id: 'qpu-faculty',
        title: 'qpu.faculty.nav',
        icon: <Book size={20} />,
        navLink: '/qpu/faculty',
        action: 'call',
        resource: 'FACULTY_ADMIN'
    },
    {
        id: 'qpu-student-registrations',
        title: 'qpu.studentRegistration.nav',
        icon: <UserPlus size={20} />,
        navLink: '/qpu/student-registrations',
        action: 'call',
        resource: 'FACULTY_ADMIN'
    },
    {
        id: 'qpu-teachers',
        title: 'qpu.teacher.nav',
        icon: <Users size={20} />,
        navLink: '/qpu/teachers',
        action: 'call',
        resource: 'NoPermissionCode'
    },
    {
        id: 'qpu-study-years',
        title: 'qpu.studyYear.nav',
        icon: <Calendar size={20} />,
        navLink: '/qpu/study-years',
        action: 'call',
        resource: 'NoPermissionCode'
    },
    {
        id: 'qpu-graduated-students',
        title: 'qpu.graduatedStudent.nav',
        icon: <UserCheck size={20} />,
        navLink: '/qpu/graduated-students',
        action: 'call',
        resource: 'FACULTY_ADMIN'
    },
    {
        id: 'qpu-scientific-research',
        title: 'qpu.scientificResearch.nav',
        icon: <Award size={20} />,
        navLink: '/qpu/scientific-research',
        action: 'call',
        resource: 'FACULTY_ADMIN'
    },
    {
        id: 'qpu-courses',
        title: 'qpu.course.nav',
        icon: <BookOpen size={20} />,
        navLink: '/qpu/courses',
        action: 'call',
        resource: 'FACULTY_ADMIN'
    },
    {
        id: 'qpu-lectures',
        title: 'qpu.lecture.nav',
        icon: <PlayCircle size={20} />,
        navLink: '/qpu/lectures',
        action: 'call',
        resource: 'FACULTY_ADMIN'
    },
    {
        id: 'qpu-labs',
        title: 'qpu.lab.nav',
        icon: <Grid size={20} />,
        navLink: '/qpu/labs',
        action: 'call',
        resource: 'FACULTY_ADMIN'
    },
    {
        id: 'qpu-dynamic-content',
        title: 'qpu.dynamicContent.nav',
        icon: <Layers size={20} />,
        navLink: '/qpu/dynamic-content',
        action: 'call',
        resource: 'NoPermissionCode'
    },
    {
        id: 'qpu-dynamic-content-duplicates',
        title: 'qpu.dynamicContent.duplicatesNav',
        icon: <Copy size={20} />,
        navLink: '/qpu/dynamic-content/duplicates',
        action: 'call',
        resource: 'NoPermissionCode'
    },
    {
        id: 'qpu-best-employees',
        title: 'qpu.bestEmployee.nav',
        icon: <Star size={20} />,
        navLink: '/qpu/best-employees',
        action: 'call',
        resource: 'FACULTY_ADMIN'
    },
    {
        id: 'qpu-vacancies',
        title: 'qpu.vacancy.nav',
        icon: <Users size={20} />,
        navLink: '/qpu/vacancies',
        action: 'call',
        resource: 'NoPermissionCode'
    }

]
